// @file Composable to manage whiteboard AI chat state.
import device from '@@/bits/device'
import { isAppUsing } from '@@/bits/flip'
import { useSurfaceAccountsStore } from '@@/pinia/surface_accounts_store'
import { useSurfaceContainerSizeStore } from '@@/pinia/surface_container_size'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { computed, type ComputedRef } from 'vue'

function useWhiteboardAIChat(): { xAiChat: ComputedRef<boolean> } {
  const surfaceAccountsStore = useSurfaceAccountsStore()
  const surfaceContainerSizeStore = useSurfaceContainerSizeStore()
  const surfacePermissionsStore = useSurfacePermissionsStore()

  const xAiChat = computed(() => {
    if (!isAppUsing('piSandboxChat')) return false
    if (device.app) return false
    if (surfaceContainerSizeStore.isContainerSmallerThanTabletPortrait) return false

    if (isAppUsing('surfaceAiChatSchools') && surfaceAccountsStore.isEducationalLibrary) {
      return surfaceAccountsStore.currentLibrary?.libraryAccess?.canUsePadletIntelligence || false
    }

    if (!surfacePermissionsStore.amIOwner) return false

    if (surfaceAccountsStore.isLibraryTeacherOrAbove || surfaceAccountsStore.isBackpackTeacherOrAbove) {
      return true
    }

    return false
  })

  return {
    xAiChat,
  }
}

export { useWhiteboardAIChat }
